import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ApiUrls } from "./ApiUrls";
import { MatSnackBar } from "@angular/material/snack-bar";
import { InstallmentConfigurationInitFormResponseModel } from "../model/InstallmentConfigurationInitFormResponseModel";
import { InstallmentConfigurationLotteryInitFormResponseModel } from "../model/InstallmentConfigurationLotteryInitFormResponseModel";
import { InstallmentConfigurationSchemeInitFormResponseModel } from "../model/InstallmentConfigurationSchemeInitFormResponseModel";
import { LotteryInstallmentConfigurationModel } from "../model/LotteryInstallmentConfigurationModel";
import { SchemeInstallmentConfigurationModel } from "../model/SchemeInstallmentConfigurationModel";

@Injectable({
  providedIn: "root",
})
export class InstallmentConfigService {
  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) {}

  initInstallmentConfigurationForm() {
    return this.httpClient.get<InstallmentConfigurationInitFormResponseModel>(
      ApiUrls.installmentConfigInitFormUrl
    );
  }

  initWithLottery(lotteryKey: number) {
    return this.httpClient.get<InstallmentConfigurationLotteryInitFormResponseModel>(
      ApiUrls.installmentConfigInitWithLotteryUrl.replace(
        "{lotteryKey}",
        lotteryKey.toString()
      )
    );
  }
  viewWithLottery(lotteryKey: number, installmentType: string) {
    return this.httpClient.get<InstallmentConfigurationLotteryInitFormResponseModel>(
      ApiUrls.viewinstallmentConfigInitWithLotteryUrl
        .replace("{lotteryKey}", lotteryKey.toString())
        .replace("{installmentType}", installmentType)
    );
  }
  viewWithScheme(
    lotteryKey: number,
    schemeKey: number,
    installmentType: string
  ) {
    return this.httpClient.get<InstallmentConfigurationSchemeInitFormResponseModel>(
      ApiUrls.viewinstallmentConfigInitWithSchemeUrl
        .replace("{lotteryKey}", lotteryKey.toString())
        .replace("{schemeKey}", schemeKey.toString())
        .replace("{installmentType}", installmentType)
    );
  }
  // initWithLotteryEdit(
  //   installmentType: string,
  //   lotteryKey: number,
  //   lotteryInstKey: number
  // ) {
  //   return this.httpClient.get<InstallmentConfigurationLotteryInitFormResponseModel>(
  //     ApiUrls.installmentConfigInitWithLotteryEditUrl
  //       .replace("{installmentType}", installmentType)
  //       .replace("{lotteryKey}", lotteryKey.toString())
  //       .replace("{lotteryInstKey}", lotteryInstKey.toString())
  //   );
  // }
  // initWithSchemeEdit(
  //   installmentType: string,
  //   lotteryKey: number,
  //   schemeInstKey: number
  // ) {
  //   return this.httpClient.get<InstallmentConfigurationLotteryInitFormResponseModel>(
  //     ApiUrls.installmentConfigInitWithLotteryEditUrl
  //       .replace("{installmentType}", installmentType)
  //       .replace("{lotteryKey}", lotteryKey.toString())
  //       .replace("{schemeInstKey}", schemeInstKey.toString())
  //   );
  // }
  initWithScheme(lotteryKey: number, schemeKey: number) {
    return this.httpClient.get<InstallmentConfigurationSchemeInitFormResponseModel>(
      ApiUrls.installmentConfigInitWithSchemeUrl
        .replace("{lotteryKey}", lotteryKey.toString())
        .replace("{schemeKey}", schemeKey.toString())
    );
  }

  saveLotteryInstallmentConfiguration(
    lotteryKey: number,
    data: LotteryInstallmentConfigurationModel[]
  ) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      ApiUrls.installmentConfigSaveWithLotteryUrl.replace(
        "{lotteryKey}",
        lotteryKey.toString()
      ),
      {
        lotteryInstallmentConfigs: data,
      }
    );
  }

  saveSchemeInstallmentConfiguration(
    lotteryKey: number,
    schemeKey: number,
    data: SchemeInstallmentConfigurationModel[]
  ) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      ApiUrls.installmentConfigSaveWithSchemeUrl
        .replace("{lotteryKey}", lotteryKey.toString())
        .replace("{schemeKey}", schemeKey.toString()),
      {
        schemeInstallmentConfigs: data,
      }
    );
  }

  async successToast(msg) {
    await this._snackBar.open(msg, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }

  initInstallmentConfiguration() {
    return this.httpClient.get<InstallmentConfigurationInitFormResponseModel>(
      ApiUrls.newPaymentExtensionListInitUrl
    );
  }

  initWithLotterySelect(lotteryKey: number) {
    return this.httpClient.get<InstallmentConfigurationLotteryInitFormResponseModel>(
      ApiUrls.installmentConfigIniLotteryUrl.replace(
        "{lotteryKey}",
        lotteryKey.toString()
      )
    );
  }

  initWithSchemeSelect(lotteryKey: number, schemeKey: number) {
    return this.httpClient.get<InstallmentConfigurationSchemeInitFormResponseModel>(
      ApiUrls.installmentConfigInitWithSchemeSelectUrl
        .replace("{lotteryKey}", lotteryKey.toString())
        .replace("{schemeKey}", schemeKey.toString())
    );
  }
}
